<template>
  <div class="page">
    <div class="page-moderation-header">
      <ui-button
        color="red"
        size="large"
        class="logoutButton"
        @click="logoutAction"
        >Выход</ui-button
      >
    </div>
    <ui-tabs>
      <ui-tab title="Список модераторов">
        <div class="ui-button-group">
          <ui-button color="primary" @click="openModal"
            >Добавить модератора</ui-button
          >
        </div>
        <table class="moder-table">
          <thead>
            <tr>
              <th>Имя</th>
              <th>Email</th>
              <th>Статус</th>
              <th>Последний логин</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="moderator.id" v-for="moderator in moderators">
              <td>{{ moderator.first_name }} {{ moderator.last_name }}</td>
              <td>{{ moderator.email }}</td>
              <td>{{ moderator.super_moder ? "Главный" : "Обычный" }}</td>
              <td>
                {{
                  moderator.last_login
                    ? moment(moderator.last_login).format("HH:mm:ss DD.MM.YYYY")
                    : "Никогда"
                }}
              </td>
              <td>
                <ui-button
                  color="primary"
                  size="small"
                  @click="seeStats(moderator)"
                  >Просмотр статистики</ui-button
                >
                <ui-button
                  color="orange"
                  size="small"
                  @click="resetPass(moderator.id)"
                  :loading="requests.reset[moderator.id]"
                  >Сброс пароля</ui-button
                >
                <ui-button
                  color="green"
                  size="small"
                  @click="openModal(moderator)"
                  >Редактировать</ui-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </ui-tab>
      <ui-tab title="Статистика">
        <div class="moderator-filter">
          <h4>Период отображения данных</h4>
          <ui-radio-group
            name="dateFilter"
            v-model="logsFilter.datePeriod"
            :options="[
              { label: 'Всё', value: 'all' },
              { label: 'Вчера', value: 'yesterday' },
              { label: 'Неделя', value: 'lastWeek' },
              { label: 'Месяц', value: 'lastMonth' },
              { label: 'Год', value: 'lastYear' }
            ]"
            @change="updateLogs"
          ></ui-radio-group>
          <ui-select
            has-search
            label="Выбор модератора"
            multiple
            v-model="logsFilter.showModerators"
            :options="moderatorEmails"
            @change="updateLogs"
          ></ui-select>
        </div>
        <table class="moder-table">
          <thead>
            <tr>
              <th>Дата и время</th>
              <th>Модератор</th>
              <th>Страница</th>
              <th>Действие</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="log.id" v-for="log in visibleLogs">
              <td>{{ moment(log.date).format("HH:mm:ss DD.MM.YYYY") }}</td>
              <td>{{ log.moderator.email }}</td>
              <td>{{ log.entry_data.page_url }}</td>
              <td v-if="log.entry_data.type === 'change_status'">
                Изменен статус
                <span class="old" :class="log.entry_data.old_status.value">
                  {{ log.entry_data.old_status.label }}</span
                >
                ->
                <span class="new" :class="log.entry_data.new_status.value">{{
                  log.entry_data.new_status.label
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <ui-button v-if="logsFilter.overly" @click="loadMore"
          >Загрузить ещё</ui-button
        >
      </ui-tab>
    </ui-tabs>
    <div class="ui-button-group">
      <ui-button @click="$router.push('/moderator')">
        К модерации
      </ui-button>
    </div>
    <ui-modal
      ref="moderatorModal"
      class="Background"
      dismiss-on="close-button esc"
    >
      <h2 slot="header">{{ modalTitle }}</h2>
      <form @submit.prevent="addModerator">
        <ui-textbox
          v-model="modalModerator.first_name"
          placeholder="Имя"
          name="first_name"
          required
        ></ui-textbox>
        <ui-textbox
          v-model="modalModerator.last_name"
          placeholder="Фамилия"
          name="last_name"
          required
        ></ui-textbox>
        <ui-textbox
          v-model="modalModerator.email"
          placeholder="Email"
          name="email"
          required
        ></ui-textbox>
        <ui-select
          v-model="modalModerator.type"
          :options="moderatorTypes"
        ></ui-select>
        <ui-checkbox :value="true" v-model="modalModerator.super_moder"
          >Главный модератор</ui-checkbox
        >
        <ui-button :loading="requests.saving">Сохранить</ui-button>
        <ui-button @click="$refs.moderatorModal.close()">Отменить</ui-button>
      </form>
    </ui-modal>
    <ui-modal
      ref="statModal"
      dismiss-on="close-button esc"
      @close="clearStatModerator"
    >
      <h2 slot="header">Статистика модератора</h2>
      <div v-if="statModerator">
        <h4>
          Модератор: {{ statModerator.first_name }}
          {{ statModerator.last_name }}
        </h4>
        <div>Email: {{ statModerator.email }}</div>
        <div>Совершено действий: {{ statModerator.stats.total }}</div>
        <div>Страниц принято: {{ statModerator.stats.accepted }}</div>
        <div>Страниц отклонено: {{ statModerator.stats.declined }}</div>
        <div>Страниц заблокировано: {{ statModerator.stats.blocked }}</div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

require("moment/locale/ru");
moment.locale("ru");

export default {
  name: "SupermoderatorPanel",
  data() {
    return {
      moderators: [],
      logs: [],
      visibleLogs: [],
      requests: {
        reset: {},
        saving: false
      },
      logsFilter: {
        datePeriod: "all",
        showModerators: [],
        offset: 0,
        limit: 100,
        overly: false
      },
      statModerator: null,
      modalModerator: {
        id: null,
        first_name: "",
        last_name: "",
        email: "",
        type: { label: "Amway", value: "amway" },
        super_moder: false
      },
      modalTitle: "Новый модератор",
      moderatorTypes: [
        { label: "Amway", value: "amway" },
        { label: "Contractor", value: "contractor" },
        { label: "Other", value: "other" }
      ]
    };
  },
  created() {
    return fetch("/api/moderation/super/list", {
      credentials: "include"
    })
      .then(r => r.json())
      .then(r => {
        if (r.status === "success") {
          this.moderators = r.result;
          this.moderators.forEach(m => (this.requests.reset[m.id] = false));
        } else {
          console.error("some error");
        }
        return fetch(
          `/api/moderation/super/stats?offset=${this.logsFilter.offset}&limit=${this.logsFilter.limit}`,
          {
            credentials: "include"
          }
        );
      })
      .then(r => r.json())
      .then(r => {
        this.logs = r.result.list;
        this.logsFilter.overly = r.result.overly;
        this.visibleLogs = this.logs.slice();
      });
  },
  computed: {
    moderatorEmails() {
      return this.moderators.map(m => m.email);
    }
  },
  methods: {
    ...mapActions(["logoutAction"]),
    moment,
    openModal(moderator = null) {
      if (moderator) {
        this.modalTitle = "Редактирование модератора";
        this.modalModerator.id = moderator.id;
        this.modalModerator.first_name = moderator.first_name;
        this.modalModerator.last_name = moderator.last_name;
        this.modalModerator.email = moderator.email;
        this.modalModerator.super_moder = moderator.super_moder;
        this.modalModerator.type = this.moderatorTypes.find(
          t => t.value === moderator.type
        );
      } else {
        this.modalTitle = "Новый модератор";
      }
      this.$refs.moderatorModal.open();
    },
    resetPass(id) {
      const body = new FormData();
      body.append("id", id);
      fetch("/api/moderation/super/reset_pass", {
        headers: {},
        credentials: "include",
        method: "POST",
        body: body
      })
        .then(r => r.json())
        .then(r => {
          if (r.status === "success") {
            alert("Модератор получит новый пароль по email");
          }
        });
    },
    addModerator() {
      const body = new FormData();
      body.append("first_name", this.modalModerator.first_name);
      body.append("last_name", this.modalModerator.last_name);
      body.append("email", this.modalModerator.email);
      body.append("super_moder", this.modalModerator.super_moder);
      body.append("type", this.modalModerator.type.value);
      if (this.modalModerator.id) {
        body.append("id", this.modalModerator.id);
      }
      fetch(
        `/api/moderation/super/${
          this.modalModerator.id ? "update_moderator" : "create_moderator"
        }`,
        {
          method: "POST",
          credentials: "include",
          body: body,
          headers: {}
        }
      )
        .then(r => r.json())
        .then(r => {
          if (r.status === "success") {
            this.$refs.moderatorModal.close();
            if (this.modalModerator.id) {
              this.moderators[
                this.moderators.findIndex(m => m.id === this.modalModerator.id)
              ] = r.result;
            } else {
              this.moderators.push(r.result.moderator);
            }
            this.modalModerator = {
              id: null,
              first_name: "",
              last_name: "",
              email: "",
              type: { label: "Amway", value: "amway" },
              super_moder: false
            };
          }
        });
    },
    updateLogs(more = false) {
      const filterData = {};
      const now = moment();
      const ids = this.visibleLogs.map(i => i.id);
      switch (this.logsFilter.datePeriod) {
        case "yesterday":
          filterData["date__gte"] = now.subtract(1, "d").format("YYYY-MM-DD");
          break;
        case "lastWeek":
          filterData["date__gte"] = now.subtract(7, "d").format("YYYY-MM-DD");
          break;
        case "lastMonth":
          filterData["date__gte"] = now.subtract(1, "M").format("YYYY-MM-DD");
          break;
        case "lastYear":
          filterData["date__gte"] = now.subtract(1, "y").format("YYYY-MM-DD");
          break;
      }
      if (this.logsFilter.showModerators.length) {
        filterData.moderator__user__email__in = this.logsFilter.showModerators.join(
          ","
        );
      }
      filterData.offset = this.logsFilter.offset;
      filterData.limit = this.logsFilter.limit;
      const url = `/api/moderation/super/stats?${new URLSearchParams(
        filterData
      ).toString()}`;
      return fetch(url, {
        method: "GET",
        credentials: "include"
      })
        .then(r => r.json())
        .then(r => {
          // if (more) {
            // this.logs = this.logs.concat(
              // r.result.list.filter(i => !ids.includes(i.id))
            // );
          // } else {
          this.logs = r.result.list;
          // }
          this.visibleLogs = this.logs.slice();
          this.logsFilter.overly = r.result.overly;
        });
    },
    loadMore() {
      this.logsFilter.offset += this.logsFilter.limit;
      return this.updateLogs();
    },
    seeStats(moderator) {
      return fetch(`/api/moderation/super/mod_stats/${moderator.id}`, {
        method: "GET",
        credentials: "include"
      })
        .then(r => r.json())
        .then(r => {
          this.statModerator = Object.assign({}, moderator);
          this.statModerator.stats = r.result;
          this.$refs.statModal.open();
        });
    },
    clearStatModerator() {
      this.statModerator = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0 5% 5%;
}

.moder-table {
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      border: 1px solid #e0e0e0;
    }

    th {
      padding: 10px;
    }
  }

  tbody {
    tr {
      border: 1px solid #e0e0e0;
    }

    td {
      text-align: center;
      &:last-child {
        text-align: left;
      }
      & .new {
        color: green;
      }
      & .accepted {
        color: #003a00;
        font-weight: bold;
      }
      & .changed {
        color: yellowgreen;
      }
      & .declined {
        color: darkred;
      }

      & .blocked {
        color: red;
      }

      & .old {
        display: inline-block;
        position: relative;
        &:before {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          top: 50%;
          background: #000000;
        }
      }
    }
  }
}
.page-moderation-header {
  position: relative;
}
.logoutButton {
  position: absolute;
  right: 0;
  z-index: 1;
}
</style>
